// Read-only access to the source feed (operations.incidents). The triage detail
// page loads the full incident row for metadata + the log bundle link.
import { opsDb } from '@/lib/supabase';
import type { Incident } from '@/types';

export async function getIncident(id: string): Promise<Incident | null> {
  const { data, error } = await opsDb().from('incidents').select('*').eq('id', id).maybeSingle();
  if (error) throw error;
  return data as Incident | null;
}
